import { Tooltip, Typography, Box } from "@mui/material";

interface Props {
  label: string;
  value: string | number;
}

const HoverReveal = ({ label, value }: Props) => {
  return (
    <Box sx={{ display: "inline-block", cursor: "help" }}>
      <Tooltip title={<Typography>{value}</Typography>} arrow placement="top">
        <Typography variant="body1">{label}</Typography>
      </Tooltip>
    </Box>
  );
};

export default HoverReveal;
